{
  "INBOX_MGMT": {
    "HEADER": "Posteingänge",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Mehr über Posteingänge erfahren",
    "COUNT": "{n} inbox | {n} inboxes",
    "SEARCH_PLACEHOLDER": "Search inboxes...",
    "NO_RESULTS": "No inboxes found matching your search",
    "RECONNECTION_REQUIRED": "Ihr Posteingang ist nicht verbunden. Sie erhalten keine neuen Nachrichten, bis Sie ihn erneut autorisieren.",
    "CLICK_TO_RECONNECT": "Klicken Sie hier, um die Verbindung wiederherzustellen.",
    "WHATSAPP_REGISTRATION_INCOMPLETE": "Your WhatsApp Business registration isn’t complete. Please check your display name status in Meta Business Manager before reconnecting.",
    "COMPLETE_REGISTRATION": "Complete Registration",
    "LIST": {
      "404": "Diesem Konto sind keine Posteingänge zugeordnet."
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Wählen Sie Kanal",
        "BODY": "Wählen Sie den Anbieter, den Sie in Chatwoot integrieren möchten."
      },
      "INBOX": {
        "TITLE": "Posteingang erstellen",
        "BODY": "Authentifizieren Sie Ihr Konto und erstellen Sie einen Posteingang."
      },
      "AGENT": {
        "TITLE": "Agenten hinzufügen",
        "BODY": "Fügen Sie dem erstellten Posteingang Agenten hinzu."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "Geschafft!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Posteingang-Name",
        "PLACEHOLDER": "Geben Sie den Namen für Ihren Posteingang ein (eg: Acme Inc)",
        "ERROR": "Bitte geben Sie einen gültigen Posteingangsnamen ein"
      },
      "WEBSITE_NAME": {
        "LABEL": "Webseiten-Name",
        "PLACEHOLDER": "Geben Sie den Namen Ihrer Website ein (zum Beispiel: Acme Inc)"
      },
      "FB": {
        "HELP": "PS: Durch die Anmeldung erhalten wir nur Zugriff auf die Nachrichten Ihrer Seite. Auf Ihre privaten Nachrichten kann Chatwoot niemals zugreifen.",
        "CHOOSE_PAGE": "Seite auswählen",
        "CHOOSE_PLACEHOLDER": "Wähle eine Seite aus der Liste",
        "INBOX_NAME": "Posteingang-Name",
        "ADD_NAME": "Namen für diesen Posteingang eingeben",
        "PICK_NAME": "Wählen Sie einen Namen für Ihren Posteingang aus",
        "PICK_A_VALUE": "Wählen Sie einen Wert aus",
        "CREATE_INBOX": "Posteingang erstellen"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Mit Instagram fortfahren",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Verbinde dein Instagram-Profil",
        "HELP": "To add your Instagram profile as a channel, you need to authenticate your Instagram Profile by clicking on 'Continue with Instagram' ",
        "ERROR_MESSAGE": "There was an error connecting to Instagram, please try again",
        "ERROR_AUTH": "There was an error connecting to Instagram, please try again",
        "NEW_INBOX_SUGGESTION": "This Instagram account was previously linked to a different inbox and has now been migrated here. All new messages will appear here. The old inbox will no longer be able to send or receive messages for this account.",
        "DUPLICATE_INBOX_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. You won’t be able to send/receive Instagram messages from this inbox anymore.",
        "SETTINGS_RESTRICTED_WARNING": "Instagram is currently restricted. Some messages or actions may be delayed or unavailable while we restore full support.",
        "STATUS_LINK": "View status update"
      },
      "TIKTOK": {
        "CONTINUE_WITH_TIKTOK": "Continue with TikTok",
        "CONNECT_YOUR_TIKTOK_PROFILE": "Connect your TikTok Profile",
        "HELP": "To add your TikTok profile as a channel, you need to authenticate your TikTok Profile by clicking on 'Continue with TikTok' ",
        "ERROR_MESSAGE": "There was an error connecting to TikTok, please try again",
        "ERROR_AUTH": "There was an error connecting to TikTok, please try again",
        "NORTH_AMERICA_WARNING": "TikTok connections for North American accounts are temporarily unavailable while we wait for an update from the TikTok team."
      },
      "TWITTER": {
        "HELP": "Um Ihr Twitter-Profil als Kanal hinzuzufügen, müssen Sie Ihr Twitter-Profil authentifizieren, indem Sie auf 'Mit Twitter anmelden' klicken.",
        "ERROR_MESSAGE": "Beim Verbinden mit Twitter ist ein Fehler aufgetreten, bitte versuchen Sie es erneut",
        "TWEETS": {
          "ENABLE": "Konversationen aus erwähnten Tweets erstellen"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Website-Kanal",
        "DESC": "Erstellen Sie einen Kanal für Ihre Website und unterstützen Sie Ihre Kunden über unser Website-Widget.",
        "LOADING_MESSAGE": "Website-Support-Channel erstellen",
        "CHANNEL_AVATAR": {
          "LABEL": "Kanal-Avatar"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Webhook-URL",
          "PLACEHOLDER": "Bitte geben Sie Ihre Webhook-URL ein",
          "ERROR": "Bitte geben Sie eine gültige URL ein"
        },
        "CHANNEL_WEBHOOK_SECRET": {
          "LABEL": "Webhook Secret",
          "COPY": "Copy secret to clipboard",
          "COPY_SUCCESS": "Secret copied to clipboard",
          "TOGGLE": "Toggle secret visibility",
          "RESET_SUCCESS": "Webhook secret regenerated successfully",
          "RESET_ERROR": "Unable to regenerate webhook secret. Please try again"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Website-Domain",
          "PLACEHOLDER": "Geben Sie Ihre Website-Domain ein (eg: acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Willkommens-Überschrift",
          "PLACEHOLDER": "Hallo!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Willkommens-Schlagzeile",
          "PLACEHOLDER": "Wir machen es einfach, sich mit uns zu verbinden. Fragen Sie uns etwas oder teilen Sie uns Ihr Feedback mit."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Grußnachricht des Kanals",
          "PLACEHOLDER": "Acme Inc antwortet in der Regel innerhalb weniger Stunden."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Kanal Begrüßung aktivieren",
          "HELP_TEXT": "Automatisch eine Begrüßungsnachricht senden, wenn eine neue Konversation erstellt wird.",
          "ENABLED": "Aktiviert",
          "DISABLED": "Deaktiviert"
        },
        "REPLY_TIME": {
          "TITLE": "Reaktionszeit festlegen",
          "IN_A_FEW_MINUTES": "Innerhalb weniger Minuten",
          "IN_A_FEW_HOURS": "Innerhalb weniger Stunden",
          "IN_A_DAY": "Innerhalb eines Tages",
          "HELP_TEXT": "Diese Antwortzeit wird im Live-Chat-Widget angezeigt"
        },
        "WIDGET_COLOR": {
          "LABEL": "Widget Farbe",
          "PLACEHOLDER": "Aktualisieren Sie die im Widget verwendete Widget-Farbe"
        },
        "SUBMIT_BUTTON": "Posteingang erstellen",
        "API": {
          "ERROR_MESSAGE": "Wir konnten keinen Website-Kanal erstellen, bitte versuchen Sie es erneut"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/WhatsApp-Kanal",
        "DESC": "Integrieren Sie Twilio und unterstützen Sie Ihre Kunden via SMS oder WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "Account SID",
          "PLACEHOLDER": "Bitte geben Sie Ihre Twilio Account SID ein",
          "ERROR": "Dieses Feld wird benötigt"
        },
        "API_KEY": {
          "USE_API_KEY": "Verwenden Sie die API-Schlüssel-Authentifizierung",
          "LABEL": "API-Schlüssel SID",
          "PLACEHOLDER": "Bitte geben Sie Ihre API-Schlüssel SID ein",
          "ERROR": "Dieses Feld wird benötigt"
        },
        "API_KEY_SECRET": {
          "LABEL": "API-Schlüssel-Geheimnis",
          "PLACEHOLDER": "Bitte geben Sie Ihr API-Schlüssel-Geheimnis ein",
          "ERROR": "Dieses Feld wird benötigt"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Messaging-Dienst-SID",
          "PLACEHOLDER": "Bitte geben Sie Ihre Twilio Messaging Service SID ein",
          "ERROR": "Dieses Feld wird benötigt",
          "USE_MESSAGING_SERVICE": "Verwenden Sie einen Twilio-Nachrichtendienst"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Kanal-Typ",
          "ERROR": "Bitte wählen Sie den Kanal-Typ aus"
        },
        "AUTH_TOKEN": {
          "LABEL": "Auth-Token",
          "PLACEHOLDER": "Bitte geben Sie Ihr Twilio Auth Token ein",
          "ERROR": "Dieses Feld wird benötigt"
        },
        "CHANNEL_NAME": {
          "LABEL": "Posteingang-Name",
          "PLACEHOLDER": "Bitte geben Sie einen Namen für den Posteingang ein",
          "ERROR": "Dieses Feld wird benötigt"
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefonnummer",
          "PLACEHOLDER": "Bitte geben Sie die Telefonnummer ein, von der die Nachricht gesendet wird.",
          "ERROR": "Bitte geben Sie eine gültige Telefonnummer an, die mit einem `+` Zeichen beginnt und keine Leerzeichen enthält."
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "Sie müssen die Callback-URL in Twilio mit der hier genannten URL konfigurieren."
        },
        "SUBMIT_BUTTON": "Erstellen Sie Twilio Channel",
        "API": {
          "ERROR_MESSAGE": "Wir konnten die Twilio-Anmeldeinformationen nicht authentifizieren. Bitte versuchen Sie es erneut"
        }
      },
      "SMS": {
        "TITLE": "SMS Kanal",
        "DESC": "Beginnen Sie, Ihre Kunden per SMS zu unterstützen.",
        "PROVIDERS": {
          "LABEL": "API-Provider",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandbreite"
        },
        "API": {
          "ERROR_MESSAGE": "Wir konnten den SMS-Kanal nicht speichern"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "Account ID",
            "PLACEHOLDER": "Bitte geben Sie Ihre Bandbreitenkonto-ID ein",
            "ERROR": "Dieses Feld wird benötigt"
          },
          "API_KEY": {
            "LABEL": "API-Schlüssel",
            "PLACEHOLDER": "Bitte geben Sie Ihren Bandbreiten-API-Schlüssel ein",
            "ERROR": "Dieses Feld wird benötigt"
          },
          "API_SECRET": {
            "LABEL": "API-Secret",
            "PLACEHOLDER": "Bitte geben Sie Ihr Bandbreiten-API-Geheimnis ein",
            "ERROR": "Dieses Feld wird benötigt"
          },
          "APPLICATION_ID": {
            "LABEL": "Anwendungs-ID",
            "PLACEHOLDER": "Bitte geben Sie Ihre Bandbreitenanwendungs-ID ein",
            "ERROR": "Dieses Feld wird benötigt"
          },
          "INBOX_NAME": {
            "LABEL": "Posteingang-Name",
            "PLACEHOLDER": "Bitte geben Sie einen Namen für den Posteingang ein",
            "ERROR": "Dieses Feld wird benötigt"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefonnummer",
            "PLACEHOLDER": "Bitte geben Sie die Telefonnummer ein, von der die Nachricht gesendet wird.",
            "ERROR": "Bitte geben Sie eine gültige Telefonnummer an, die mit einem `+` Zeichen beginnt und keine Leerzeichen enthält."
          },
          "SUBMIT_BUTTON": "Bitte geben Sie Ihre Bandbreitenanwendungs-ID ein",
          "API": {
            "ERROR_MESSAGE": "Wir konnten die Bandbreiten-Anmeldeinformationen nicht authentifizieren. Bitte versuchen Sie es erneut"
          },
          "API_CALLBACK": {
            "TITLE": "Callback URL",
            "SUBTITLE": "Sie müssen die Nachrichten-Callback-URL in Bandbreite mit der hier erwähnten URL konfigurieren."
          }
        }
      },
      "WHATSAPP": {
        "TITLE": "WhatsApp-Kanal",
        "DESC": "Unterstützen Sie Ihre Kunden via WhatsApp.",
        "PROVIDERS": {
          "LABEL": "API-Provider",
          "WHATSAPP_EMBEDDED": "WhatsApp Business",
          "TWILIO": "Twilio",
          "WHATSAPP_CLOUD": "WhatsApp Cloud",
          "WHATSAPP_CLOUD_DESC": "Quick setup through Meta",
          "TWILIO_DESC": "Connect via Twilio credentials",
          "360_DIALOG": "360Dialog"
        },
        "SELECT_PROVIDER": {
          "TITLE": "Wähle deinen API-Provider",
          "DESCRIPTION": "Choose your WhatsApp provider. You can connect directly through Meta which requires no setup, or connect through Twilio using your account credentials."
        },
        "INBOX_NAME": {
          "LABEL": "Posteingang-Name",
          "PLACEHOLDER": "Bitte geben Sie einen Namen für den Posteingang ein",
          "ERROR": "Dieses Feld wird benötigt"
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefonnummer",
          "PLACEHOLDER": "Bitte geben Sie die Telefonnummer ein, von der die Nachricht gesendet wird.",
          "ERROR": "Bitte geben Sie eine gültige Telefonnummer an, die mit einem `+` Zeichen beginnt und keine Leerzeichen enthält."
        },
        "PHONE_NUMBER_ID": {
          "LABEL": "Telefonnummer-ID",
          "PLACEHOLDER": "Bitte geben Sie die Telefonnummern-ID ein, die Sie vom Facebook-Entwickler-Dashboard erhalten haben.",
          "ERROR": "Bitte geben Sie einen gültigen Wert ein."
        },
        "BUSINESS_ACCOUNT_ID": {
          "LABEL": "Geschäftskonto-ID",
          "PLACEHOLDER": "Bitte geben Sie die von Facebook Developer Dashboard erhaltene Geschäftskonto -ID ein.",
          "ERROR": "Bitte geben Sie einen gültigen Wert ein."
        },
        "WEBHOOK_VERIFY_TOKEN": {
          "LABEL": "Webhook-Verifizierungstoken",
          "PLACEHOLDER": "Geben Sie ein Bestätigungstoken ein, das Sie für Facebook-Webhooks konfigurieren möchten.",
          "ERROR": "Bitte geben Sie einen gültigen Wert ein."
        },
        "API_KEY": {
          "LABEL": "API-Schlüssel",
          "SUBTITLE": "Konfigurieren Sie den WhatsApp API-Schlüssel.",
          "PLACEHOLDER": "API-Schlüssel",
          "ERROR": "Bitte geben Sie einen gültigen Wert ein."
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "Sie müssen die Webhook-URL und das Verifizierungstoken im Facebook-Entwicklerportal mit den unten gezeigten Werten konfigurieren.",
          "WEBHOOK_URL": "Webhook-URL",
          "WEBHOOK_VERIFICATION_TOKEN": "Webhook-Verifizierungstoken"
        },
        "SUBMIT_BUTTON": "WhatsApp-Kanal erstellen",
        "EMBEDDED_SIGNUP": {
          "TITLE": "Quick setup with Meta",
          "DESC": "Use the WhatsApp Embedded Signup flow to quickly connect new numbers. You will be redirected to Meta to log into your WhatsApp Business account. Having admin access will help make the setup smooth and easy.",
          "BENEFITS": {
            "TITLE": "Benefits of Embedded Signup:",
            "EASY_SETUP": "No manual configuration required",
            "SECURE_AUTH": "Secure OAuth based authentication",
            "AUTO_CONFIG": "Automatic webhook and phone number configuration"
          },
          "LEARN_MORE": {
            "TEXT": "To learn more about integrated signup, pricing, and limitations, visit {link}.",
            "LINK_TEXT": "this link"
          },
          "SUBMIT_BUTTON": "Connect with WhatsApp Business",
          "AUTH_PROCESSING": "Authenticating with Meta",
          "WAITING_FOR_BUSINESS_INFO": "Please complete business setup in the Meta window...",
          "PROCESSING": "Setting up your WhatsApp Business Account",
          "ENABLING_CALLING": "Enabling WhatsApp Calling on your number…",
          "LOADING_SDK": "Loading Facebook SDK...",
          "CANCELLED": "WhatsApp Signup was cancelled",
          "SUCCESS_TITLE": "WhatsApp Business Account Connected!",
          "WAITING_FOR_AUTH": "Waiting for authentication...",
          "INVALID_BUSINESS_DATA": "Invalid business data received from Facebook. Please try again.",
          "SIGNUP_ERROR": "Signup error occurred",
          "AUTH_NOT_COMPLETED": "Authentifizierung nicht abgeschlossen. Bitte starte den Prozess neu.",
          "SUCCESS_FALLBACK": "WhatsApp Business Account wurde erfolgreich konfiguriert",
          "MANUAL_FALLBACK": "Wenn Ihre Nummer bereits mit der WhatsApp Business Plattform (API) verbunden ist, oder wenn Sie als Technologieanbieter Ihre eigene Nummer an Bord haben, verwenden Sie bitte den {link} Flow",
          "MANUAL_LINK_TEXT": "Manueller Einrichtungsablauf",
          "CALLING_ENABLE_FAILED": "Your WhatsApp inbox is ready, but voice calling couldn't be turned on — this number isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then turn calling on from the inbox's Calls settings."
        },
        "API": {
          "ERROR_MESSAGE": "Wir konnten den WhatsApp-Kanal nicht speichern"
        }
      },
      "VOICE": {
        "TITLE": "Sprachkanal",
        "DESC": "Integrate Twilio Voice and start supporting your customers via phone calls.",
        "PHONE_NUMBER": {
          "LABEL": "Telefonnummer",
          "PLACEHOLDER": "Enter your phone number (e.g. +1234567890)",
          "ERROR": "Please provide a valid phone number in E.164 format (e.g. +1234567890)"
        },
        "TWILIO": {
          "ACCOUNT_SID": {
            "LABEL": "Account SID",
            "PLACEHOLDER": "Enter your Twilio Account SID",
            "REQUIRED": "Account SID is required"
          },
          "AUTH_TOKEN": {
            "LABEL": "Auth-Token",
            "PLACEHOLDER": "Enter your Twilio Auth Token",
            "REQUIRED": "Auth Token is required"
          },
          "API_KEY_SID": {
            "LABEL": "API-Schlüssel SID",
            "PLACEHOLDER": "Enter your Twilio API Key SID",
            "REQUIRED": "API Key SID is required"
          },
          "API_KEY_SECRET": {
            "LABEL": "API-Schlüssel-Geheimnis",
            "PLACEHOLDER": "Enter your Twilio API Key Secret",
            "REQUIRED": "API Key Secret is required"
          }
        },
        "CONFIGURATION": {
          "TWILIO_VOICE_URL_TITLE": "Twilio Voice URL",
          "TWILIO_VOICE_URL_SUBTITLE": "Configure this URL as the Voice URL on your Twilio phone number and TwiML App.",
          "TWILIO_STATUS_URL_TITLE": "Twilio Status Callback URL",
          "TWILIO_STATUS_URL_SUBTITLE": "Configure this URL as the Status Callback URL on your Twilio phone number."
        },
        "SUBMIT_BUTTON": "Create Voice Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to create the voice channel"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API-Kanal",
        "DESC": "Integrieren Sie einen API-Kanal und starten Sie mit der Unterstützung Ihrer Kunden.",
        "CHANNEL_NAME": {
          "LABEL": "Kanal Name",
          "PLACEHOLDER": "Bitte geben Sie einen Kanalnamen ein",
          "ERROR": "Dieses Feld wird benötigt"
        },
        "WEBHOOK_URL": {
          "LABEL": "Webhook-URL",
          "SUBTITLE": "Konfigurieren Sie die URL, unter der Sie Rückrufe bei Ereignissen empfangen möchten.",
          "PLACEHOLDER": "Webhook-URL"
        },
        "SUBMIT_BUTTON": "API-Kanal erstellen",
        "API": {
          "ERROR_MESSAGE": "Der API-Kanal konnte nicht gespeichert werden"
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "E-Mail-Kanal",
        "DESC": "Integrieren Sie Ihren E-Mail-Posteingang.",
        "CHANNEL_NAME": {
          "LABEL": "Kanal Name",
          "PLACEHOLDER": "Bitte geben Sie einen Kanalnamen ein",
          "ERROR": "Dieses Feld wird benötigt"
        },
        "EMAIL": {
          "LABEL": "E-Mail",
          "SUBTITLE": "E-Mail Adresse, an die Ihre Kunden Ihnen Support-Tickets senden",
          "PLACEHOLDER": "E-Mail"
        },
        "SUBMIT_BUTTON": "E-Mail-Kanal erstellen",
        "API": {
          "ERROR_MESSAGE": "Wir konnten den E-Mail-Kanal nicht speichern"
        },
        "FINISH_MESSAGE": "Starten Sie die Weiterleitung Ihrer E-Mails an die folgende E-Mail-Adresse.",
        "FINISH_MESSAGE_NO_FORWARDING": "Your email inbox has been created successfully! You need to configure SMTP and IMAP credentials to send and receive emails. Without these settings, no emails will be processed.",
        "FORWARDING_ADDRESS_LABEL": "Forward emails to this address:",
        "CONFIGURE_SMTP_IMAP_LINK": "Hier klicken",
        "CONFIGURE_SMTP_IMAP_TEXT": " to configure IMAP and SMTP settings"
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE-Kanal",
        "DESC": "Integrieren Sie den LINE-Kanal und unterstützen Sie Ihre Kunden.",
        "CHANNEL_NAME": {
          "LABEL": "Kanal Name",
          "PLACEHOLDER": "Bitte geben Sie einen Kanalnamen ein",
          "ERROR": "Dieses Feld wird benötigt"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "LINE-Kanal-ID",
          "PLACEHOLDER": "LINE-Kanal-ID"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "LINE-Kanal-Geheimnis",
          "PLACEHOLDER": "LINE-Kanal-Secret"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "LINE-Kanal-Token",
          "PLACEHOLDER": "LINE-Kanal-Token"
        },
        "SUBMIT_BUTTON": "LINE-Kanal erstellen",
        "API": {
          "ERROR_MESSAGE": "Wir konnten den LINE-Kanal nicht speichern"
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "Sie müssen die Webhook-URL in der LINE-Anwendung mit der hier genannten URL konfigurieren."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegram-Kanal",
        "DESC": "Integrieren Sie den Telegram-Kanal und unterstützen Sie Ihre Kunden.",
        "BOT_TOKEN": {
          "LABEL": "Bot-Token",
          "SUBTITLE": "Konfigurieren Sie den Bot-Token, welchen Sie von Telegram BotFather erhalten haben.",
          "PLACEHOLDER": "Bot-Token"
        },
        "SUBMIT_BUTTON": "Telegram-Kanal erstellen",
        "API": {
          "ERROR_MESSAGE": "Wir konnten den Telegram-Kanal nicht speichern"
        }
      },
      "AUTH": {
        "TITLE": "Wählen Sie einen Kanal",
        "DESC": "Chatwoot unterstützt Live-Chat-Widgets, Facebook Messenger, Twitter-Profile, WhatsApp, E-Mails usw. als Kanäle. Wenn Sie einen benutzerdefinierten Kanal erstellen möchten, können Sie ihn mithilfe des API-Kanals erstellen. Wählen Sie zunächst einen der folgenden Kanäle aus.",
        "TITLE_NEXT": "Complete the setup",
        "TITLE_FINISH": "Voilà!",
        "CHANNEL": {
          "WEBSITE": {
            "TITLE": "Webseite",
            "DESCRIPTION": "Create a live-chat widget"
          },
          "FACEBOOK": {
            "TITLE": "Facebook",
            "DESCRIPTION": "Connect your Facebook page"
          },
          "WHATSAPP": {
            "TITLE": "WhatsApp",
            "DESCRIPTION": "Support your customers on WhatsApp"
          },
          "WHATSAPP_CALL": {
            "TITLE": "WhatsApp Call",
            "DESCRIPTION": "Take voice calls on your WhatsApp number"
          },
          "EMAIL": {
            "TITLE": "E-Mail",
            "DESCRIPTION": "Connect with Gmail, Outlook, or other providers"
          },
          "SMS": {
            "TITLE": "SMS",
            "DESCRIPTION": "Integrate SMS channel with Twilio or bandwidth"
          },
          "API": {
            "TITLE": "API",
            "DESCRIPTION": "Make a custom channel using our API"
          },
          "TELEGRAM": {
            "TITLE": "Telegramm",
            "DESCRIPTION": "Configure Telegram channel using Bot token"
          },
          "LINE": {
            "TITLE": "Line",
            "DESCRIPTION": "Integrate your Line channel"
          },
          "INSTAGRAM": {
            "TITLE": "Instagram",
            "DESCRIPTION": "Connect your instagram account"
          },
          "TIKTOK": {
            "TITLE": "TikTok",
            "DESCRIPTION": "Connect your TikTok account"
          },
          "VOICE": {
            "TITLE": "Voice",
            "DESCRIPTION": "Integrate with Twilio Voice"
          }
        }
      },
      "AGENTS": {
        "TITLE": "Agenten",
        "DESC": "Hier können Sie Agenten hinzufügen, um Ihren neu erstellten Posteingang zu verwalten. Nur diese ausgewählten Agenten haben Zugriff auf Ihren Posteingang. Agenten, die nicht Teil dieses Posteingangs sind, können bei der Anmeldung keine Nachrichten in diesem Posteingang sehen oder darauf antworten. <br> <b> PS: </b> Wenn Sie als Administrator Zugriff auf alle Posteingänge benötigen, sollten Sie sich als Agent zu allen von Ihnen erstellten Posteingängen hinzufügen.",
        "VALIDATION_ERROR": "Fügen Sie mindestens einen Agenten zu Ihrem neuen Posteingang hinzu",
        "PICK_AGENTS": "Agenten für den Posteingang auswählen"
      },
      "DETAILS": {
        "TITLE": "Posteingangsdetails",
        "DESC": "Wählen Sie aus der Dropdown-Liste die Facebook-Seite aus, zu der Sie eine Verbindung zu Chatwoot herstellen möchten. Sie können Ihrem Posteingang auch einen benutzerdefinierten Namen geben, um ihn besser identifizieren zu können."
      },
      "FINISH": {
        "TITLE": "Geschafft!",
        "DESC": "Sie haben die Integration Ihrer Facebook-Seite in Chatwoot erfolgreich abgeschlossen. Wenn ein Kunde das nächste Mal eine Nachricht an Ihre Seite sendet, wird die Konversation automatisch in Ihrem Posteingang angezeigt. <br> Wir stellen Ihnen außerdem ein Widget-Skript zur Verfügung, das Sie ganz einfach zu Ihrer Website hinzufügen können. Sobald dies auf Ihrer Website live ist, können Kunden Ihnen ohne Hilfe eines externen Tools direkt von Ihrer Website aus eine Nachricht senden, und die Konversation wird direkt hier auf Chatwoot angezeigt. <br> Cool, oder? Nun, wir versuchen es auf jeden Fall :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Wählen Sie Ihren E-Mail-Anbieter",
        "DESCRIPTION": "Wählen Sie einen E-Mail-Anbieter aus der Liste unten. Wenn Ihr E-Mail-Provider nicht in der Liste steht, können Sie die 'Anderer Anbieter'-Option auswählen und die Zugangsdaten für IMAP und SMTP angeben."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Klicken Sie auf die Schaltfläche Einloggen mit Microsoft, um loszulegen. Sie werden zur E-Mail-Anmeldeseite weitergeleitet. Sobald Sie die angeforderten Berechtigungen angenommen haben, werden Sie zum Erstellungsschritt für den Posteingang weitergeleitet.",
        "EMAIL_PLACEHOLDER": "E-Mail-Adresse eingeben",
        "SIGN_IN": "Mit Microsoft anmelden",
        "ERROR_MESSAGE": "Beim Verbinden mit Microsoft ist ein Fehler aufgetreten, bitte versuchen Sie es erneut"
      },
      "GOOGLE": {
        "TITLE": "Google E-Mail",
        "DESCRIPTION": "Klicken Sie auf die Schaltfläche Einloggen mit Google, um loszulegen. Sie werden zur E-Mail-Anmeldeseite weitergeleitet. Sobald Sie die angeforderten Berechtigungen angenommen haben, werden Sie zum Erstellungsschritt für den Posteingang weitergeleitet.",
        "SIGN_IN": "Mit Google anmelden",
        "EMAIL_PLACEHOLDER": "E-Mail-Adresse eingeben",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Authentifizierung mit Facebook ...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Es ist ein Fehler aufgetreten. Bitte Seite aktualisieren ...",
      "ERROR_FB_UNAUTHORIZED": "Sie sind nicht berechtigt, diese Aktion auszuführen. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Bitte stellen Sie sicher, dass Sie vollen Zugriff auf die Facebook-Seite haben. Weitere Informationen zu Facebook-Rollen finden Sie <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "CREATING_CHANNEL": "Erstellen Sie Ihren Posteingang ...",
      "TITLE": "Posteingangsdetails konfigurieren",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Agenten hinzufügen",
      "ADD_AGENTS": "Adding Agents to your Inbox...Hinzufügen von Agenten zu Ihrem Posteingang ..."
    },
    "FINISH": {
      "TITLE": "Ihr Posteingang ist fertig!",
      "MESSAGE": "Sie können jetzt über Ihren neuen Kanal mit Ihren Kunden in Kontakt treten. Fröhliches Unterstützen",
      "BUTTON_TEXT": "Bring mich dahin",
      "MORE_SETTINGS": "Weitere Einstellungen",
      "WEBSITE_SUCCESS": "Sie haben die Erstellung eines Website-Kanals erfolgreich abgeschlossen. Kopieren Sie den unten gezeigten Code und fügen Sie ihn in Ihre Website ein. Wenn ein Kunde das nächste Mal den Live-Chat verwendet, wird die Konversation automatisch in Ihrem Posteingang angezeigt.",
      "WHATSAPP_QR_INSTRUCTION": "Scan the QR code above to quickly test your WhatsApp inbox",
      "MESSENGER_QR_INSTRUCTION": "Scan the QR code above to quickly test your Facebook Messenger inbox",
      "TELEGRAM_QR_INSTRUCTION": "Scan the QR code above to quickly test your Telegram inbox"
    },
    "REAUTH": "Neu autorisieren",
    "VIEW": "Aussicht",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Posteingangseinstellungen erfolgreich aktualisiert",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Automatische Zuordnung erfolgreich aktualisiert",
        "ERROR_MESSAGE": "Die Posteingangseinstellungen konnten nicht aktualisiert werden. Bitte versuchen Sie es später erneut."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Aktiviert",
        "DISABLED": "Deaktiviert"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Aktiviert",
        "DISABLED": "Deaktiviert"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Name des Absenders",
        "SUB_TEXT": "Wählen Sie den Namen aus, der Ihren Kunden angezeigt wird, wenn sie E-Mails von Ihren Agenten erhalten.",
        "FOR_EG": "Zum Beispiel:",
        "FRIENDLY": {
          "TITLE": "Freundlich",
          "FROM": "von",
          "SUBTITLE": "Fügen Sie den Namen des Agenten, der die Antwort gesendet hat, in den Absendernamen ein, um es freundlicher zu gestalten."
        },
        "PROFESSIONAL": {
          "TITLE": "Professionell",
          "SUBTITLE": "Verwenden Sie nur den konfigurierten Firmennamen als Absendernamen in der E-Mail-Kopfzeile."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "Konfigurieren Sie Ihren Firmennamen",
          "PLACEHOLDER": "Geben Sie Ihren Firmennamen ein",
          "SAVE_BUTTON_TEXT": "Speichern"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Aktiviert",
        "DISABLED": "Deaktiviert"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Aktiviert",
        "DISABLED": "Deaktiviert"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Reopen same conversation",
        "DISABLED": "Create new conversations",
        "ENABLED_DESCRIPTION": "When a contact messages again, the previous conversation will be reopened.",
        "DISABLED_DESCRIPTION": "A new conversation will be created each time after the previous one is resolved."
      },
      "ENABLE_HMAC": {
        "LABEL": "Aktivieren"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Löschen",
      "AVATAR_DELETE_BUTTON_TEXT": "Avatar löschen",
      "CONFIRM": {
        "TITLE": "Löschung bestätigen",
        "MESSAGE": "Bist du sicher, das du das löschen möchtest ",
        "PLACE_HOLDER": "Bitte geben Sie {inboxName} zur Bestätigung ein",
        "YES": "Ja, löschen",
        "NO": "Nein, behalten "
      },
      "API": {
        "SUCCESS_MESSAGE": "Posteingang erfolgreich gelöscht",
        "ERROR_MESSAGE": "Posteingang konnte nicht gelöscht werden. Bitte versuchen Sie es später noch einmal.",
        "AVATAR_SUCCESS_MESSAGE": "Avatar von Posteingang erfolgreich gelöscht",
        "AVATAR_ERROR_MESSAGE": "Der Avatar vom Posteingang konnte nicht gelöscht werden. Bitte versuchen Sie es später erneut."
      }
    },
    "TABS": {
      "SETTINGS": "Einstellungen",
      "COLLABORATORS": "Mitarbeitende",
      "CONFIGURATION": "Konfiguration",
      "CAMPAIGN": "Kampagnen",
      "PRE_CHAT_FORM": "Pre-Chat-Formular",
      "BUSINESS_HOURS": "Öffnungszeiten",
      "WIDGET_BUILDER": "Widget-Generator",
      "BOT_CONFIGURATION": "Bot-Konfiguration",
      "ACCOUNT_HEALTH": "Account Health",
      "CSAT": "CSAT",
      "VOICE": "Voice",
      "CALLS": "Calls"
    },
    "VOICE_CONFIGURATION": {
      "ENABLE_VOICE": {
        "LABEL": "Enable Voice Calling",
        "DESCRIPTION": "Enable voice calling on this inbox. Agents will be able to make and receive phone calls."
      },
      "CREDENTIALS": {
        "DESCRIPTION": "Voice calling requires Twilio API Key credentials. These are used to generate tokens for agent voice connections."
      },
      "INBOUND": {
        "LABEL": "Allow incoming calls",
        "DESCRIPTION": "Let customers call this number. When turned off, incoming calls are declined automatically — agents aren't notified and no conversation is created. Agents can still place outgoing calls."
      }
    },
    "WHATSAPP_CALLING": {
      "ENABLE": {
        "LABEL": "Enable WhatsApp Calling",
        "DESCRIPTION": "Allow agents to receive and place WhatsApp Cloud calls on this inbox. Customers can call this business number directly from WhatsApp."
      },
      "ENABLE_FAILED": "Voice calling couldn't be turned on for this number — it isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then try again.",
      "PHONE_NUMBER": {
        "LABEL": "Business phone number",
        "HELP_TEXT": "WhatsApp number that customers will call."
      },
      "HOW_IT_WORKS": {
        "LABEL": "How it works",
        "DESCRIPTION": "Calls are placed peer-to-peer between the agent's browser and Meta — no extra credentials are required. Make sure the agent's browser has microphone permission for this site."
      },
      "PERMISSION_REQUEST_BODY": {
        "LABEL": "Call permission request message",
        "HELP_TEXT": "Shown to the contact when they haven't yet consented to receive calls. Leave blank to use the default.",
        "PLACEHOLDER": "We would like to call you regarding your conversation."
      }
    },
    "CHANNEL_PREFERENCES": "Channel Preferences",
    "WIDGET_FEATURES": "Widget features",
    "ACCOUNT_HEALTH": {
      "TITLE": "Manage your WhatsApp account",
      "DESCRIPTION": "Review your WhatsApp account status, messaging limits, and quality. Update settings or resolve issues if needed",
      "GO_TO_SETTINGS": "Go to Meta Business Manager",
      "NO_DATA": "Health data is not available",
      "FIELDS": {
        "DISPLAY_PHONE_NUMBER": {
          "LABEL": "Display phone number",
          "TOOLTIP": "Phone number displayed to customers"
        },
        "VERIFIED_NAME": {
          "LABEL": "Business name",
          "TOOLTIP": "Business name verified by WhatsApp"
        },
        "DISPLAY_NAME_STATUS": {
          "LABEL": "Display name status",
          "TOOLTIP": "Status of your business name verification"
        },
        "QUALITY_RATING": {
          "LABEL": "Quality rating",
          "TOOLTIP": "WhatsApp quality rating for your account"
        },
        "MESSAGING_LIMIT_TIER": {
          "LABEL": "Messaging limit tier",
          "TOOLTIP": "Daily messaging limit for your account"
        },
        "ACCOUNT_MODE": {
          "LABEL": "Account mode",
          "TOOLTIP": "Current operating mode of your WhatsApp account"
        }
      },
      "VALUES": {
        "TIERS": {
          "TIER_250": "250 customers per 24h",
          "TIER_1000": "1K customers per 24h",
          "TIER_1K": "1K customers per 24h",
          "TIER_10K": "10K customers per 24h",
          "TIER_100K": "100K customers per 24h",
          "TIER_UNLIMITED": "Unlimited customers per 24h",
          "UNKNOWN": "Rating not available"
        },
        "STATUSES": {
          "APPROVED": "Approved",
          "PENDING_REVIEW": "Pending Review",
          "AVAILABLE_WITHOUT_REVIEW": "Available Without Review",
          "REJECTED": "Rejected",
          "DECLINED": "Declined",
          "NON_EXISTS": "Non exists"
        },
        "MODES": {
          "SANDBOX": "Sandbox",
          "LIVE": "Live"
        }
      },
      "WEBHOOK": {
        "TITLE": "Webhook Configuration",
        "DESCRIPTION": "Webhook URL is required for your WhatsApp Business Account to receive messages from customers",
        "ACTION_REQUIRED": "Webhook not configured",
        "REGISTER_BUTTON": "Register Webhook",
        "REGISTER_SUCCESS": "Webhook registered successfully",
        "REGISTER_ERROR": "Failed to register webhook. Please try again.",
        "CONFIGURED_SUCCESS": "Webhook configured successfully",
        "URL_MISMATCH": "Webhook URL mismatch"
      }
    },
    "SETTINGS": "Einstellungen",
    "FEATURES": {
      "LABEL": "Funktionen",
      "DISPLAY_FILE_PICKER": "Dateiauswahl im Widget anzeigen",
      "DISPLAY_EMOJI_PICKER": "Emoji-Auswahl im Widget anzeigen",
      "ALLOW_END_CONVERSATION": "Benutzern erlauben, die Konversation vom Widget zu beenden",
      "USE_INBOX_AVATAR_FOR_BOT": "Posteingangsname und Avatar für den Bot verwenden"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Messenger-Skript",
      "MESSENGER_SUB_HEAD": "Platzieren Sie diese Schaltfläche in Ihrem Body-Tag",
      "ALLOWED_DOMAINS": {
        "TITLE": "Allowed Domains",
        "DESCRIPTION": "Restrict which websites can embed your chat widget. For security, only add domains you own and trust. Add one or more domains separated by commas. Leave blank to allow all domains (not recommended for production).",
        "PLACEHOLDER": "example.com, www.example.com, app.example.com"
      },
      "ALLOW_MOBILE_WEBVIEW": {
        "LABEL": "Enable widget in mobile apps",
        "SUBTITLE": "Check this if you embed the widget in iOS or Android apps. Mobile apps don't send domain information, so they would be blocked by domain restrictions unless this is enabled."
      },
      "IDENTITY_VALIDATION": {
        "TITLE": "Identity Validation",
        "DESCRIPTION": "Verify user authenticity by generating secure tokens. This prevents unauthorized users from impersonating others in your chat.",
        "SECRET_KEY": "Secret Key",
        "VIEW_DOCS": "View documentation",
        "REQUIRE_LABEL": "Require identity validation for all conversations",
        "REQUIRE_DESCRIPTION": "When enabled, users must provide a valid identity token to start conversations. Requests without valid tokens will be rejected."
      },
      "INBOX_AGENTS": "Agenten",
      "INBOX_AGENTS_SUB_TEXT": "Hinzufügen oder Entfernen von Agenten zu diesem Posteingang",
      "AGENT_ASSIGNMENT": "Konversationssauftrag",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Konversationszuweisungseinstellungen aktualisieren",
      "UPDATE": "Aktualisieren",
      "ENABLE_EMAIL_COLLECT_BOX": "E-Mail-Sammelbox aktivieren",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "E-Mail-Sammelbox für neue Konversation aktivieren oder deaktivieren",
      "AUTO_ASSIGNMENT": "Aktivieren Sie die automatische Zuweisung",
      "SENDER_NAME_SECTION": "Aktivieren Sie den Agentennamen in der E-Mail",
      "SENDER_NAME_SECTION_TEXT": "Aktivieren/Deaktivieren Sie die Anzeige des Agentennamens in der E-Mail. Wenn deaktiviert, wird der Firmenname angezeigt",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Konversationskontinuität per E-Mail aktivieren",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Konversationen werden per E-Mail fortgesetzt, wenn die Kontakt-E-Mail-Adresse verfügbar ist.",
      "ENABLE_CONTINUITY_VIA_EMAIL_DISABLED_TEXT": "This feature is available on a paid plan. Upgrade to enable conversation continuity via email.",
      "LOCK_TO_SINGLE_CONVERSATION": "Conversation Routing",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Configure conversation creation for existing contacts",
      "INBOX_UPDATE_TITLE": "Posteingangseinstellungen",
      "INBOX_UPDATE_SUB_TEXT": "Posteingangseinstellungen aktualisieren",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Aktivieren oder deaktivieren Sie die automatische Zuweisung verfügbarer Agenten für neue Konversationen",
      "HMAC_VERIFICATION": "Benutzeridentitätsüberprüfung",
      "HMAC_DESCRIPTION": "Um die Identität des Benutzers zu validieren, können Sie für jeden Benutzer einen `identifier_hash` übergeben. Sie können einen HMAC sha256-Hash generieren, indem Sie den 'Bezeichner' mit dem hier gezeigten Schlüssel verwenden.",
      "HMAC_LINK_TO_DOCS": "Lesen Sie hier mehr.",
      "HMAC_MANDATORY_VERIFICATION": "Erzwinge Benutzer-Identitätsüberprüfung",
      "HMAC_MANDATORY_DESCRIPTION": "Wenn aktiviert, werden Anfragen, denen der `identifier_hash` fehlt, abgelehnt.",
      "INBOX_IDENTIFIER": "Identifizierung für Posteingang",
      "INBOX_IDENTIFIER_SUB_TEXT": "Verwenden Sie den hier angezeigten `inbox_identifier`-Token zur Authentifizierung Ihrer API-Clients.",
      "FORWARD_EMAIL_TITLE": "Weiterleitung an E-Mail",
      "FORWARD_EMAIL_SUB_TEXT": "Starten Sie die Weiterleitung Ihrer E-Mails an die folgende E-Mail-Adresse.",
      "FORWARD_EMAIL_NOT_CONFIGURED": "Forwarding emails to your inbox is currently disabled on this installation. To use this feature, it must be enabled by your administrator. Please get in touch with them to proceed.",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Nachrichten zulassen, nachdem die Konversation gelöst wurde",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Den Endbenutzern erlauben, Nachrichten zu versenden, auch wenn die Unterhaltung abgeschlossen ist.",
      "WHATSAPP_SECTION_SUBHEADER": "Dieser API Key wird für die Integration mit den WhatsApp APIs verwendet.",
      "WHATSAPP_SECTION_UPDATE_SUBHEADER": "Geben Sie den neuen API-Schlüssel ein, der für die Integration mit den WhatsApp-APIs verwendet werden soll.",
      "WHATSAPP_SECTION_TITLE": "API-Schlüssel",
      "WHATSAPP_SECTION_UPDATE_TITLE": "API-Schlüssel aktualisieren",
      "WHATSAPP_SECTION_UPDATE_PLACEHOLDER": "Neuen API-Schlüssel hier eingeben",
      "WHATSAPP_SECTION_UPDATE_BUTTON": "Aktualisieren",
      "WHATSAPP_EMBEDDED_SIGNUP_TITLE": "WhatsApp Embedded Signup",
      "WHATSAPP_EMBEDDED_SIGNUP_SUBHEADER": "This inbox is connected through WhatsApp embedded signup.",
      "WHATSAPP_EMBEDDED_SIGNUP_DESCRIPTION": "You can reconfigure this inbox to update your WhatsApp Business settings.",
      "WHATSAPP_RECONFIGURE_BUTTON": "Reconfigure",
      "WHATSAPP_MANUAL_TRANSFER_TITLE": "Switch to Manual Setup",
      "WHATSAPP_MANUAL_TRANSFER_SUBHEADER": "This inbox was connected through WhatsApp embedded signup, which is no longer supported. Enter the WhatsApp Cloud API credentials from your own Meta app to switch this inbox to a manual setup. Configure the webhook in your Meta app using the verification token above before switching.",
      "WHATSAPP_MANUAL_TRANSFER_PHONE_NUMBER_ID_LABEL": "Phone Number ID",
      "WHATSAPP_MANUAL_TRANSFER_BUSINESS_ACCOUNT_ID_LABEL": "Geschäftskonto-ID",
      "WHATSAPP_MANUAL_TRANSFER_API_KEY_LABEL": "API-Schlüssel",
      "WHATSAPP_MANUAL_TRANSFER_API_KEY_PLACEHOLDER": "Enter a permanent access token from your Meta app",
      "WHATSAPP_MANUAL_TRANSFER_BUTTON": "Switch to Manual Setup",
      "WHATSAPP_MANUAL_TRANSFER_SUCCESS": "Inbox switched to manual setup successfully.",
      "WHATSAPP_MANUAL_TRANSFER_ERROR": "Could not switch to manual setup. Please verify the credentials and try again.",
      "WHATSAPP_CONNECT_TITLE": "Connect to WhatsApp Business",
      "WHATSAPP_CONNECT_SUBHEADER": "Upgrade to WhatsApp embedded signup for easier management.",
      "WHATSAPP_CONNECT_DESCRIPTION": "Connect this inbox to WhatsApp Business for enhanced features and easier management.",
      "WHATSAPP_CONNECT_BUTTON": "Verbinden",
      "WHATSAPP_CONNECT_SUCCESS": "Successfully connected to WhatsApp Business!",
      "WHATSAPP_CONNECT_ERROR": "Failed to connect to WhatsApp Business. Please try again.",
      "WHATSAPP_RECONFIGURE_SUCCESS": "Successfully reconfigured WhatsApp Business!",
      "WHATSAPP_RECONFIGURE_ERROR": "Failed to reconfigure WhatsApp Business. Please try again.",
      "WHATSAPP_APP_ID_MISSING": "WhatsApp App ID is not configured. Please contact your administrator.",
      "WHATSAPP_CONFIG_ID_MISSING": "WhatsApp Configuration ID is not configured. Please contact your administrator.",
      "WHATSAPP_LOGIN_CANCELLED": "WhatsApp login was cancelled. Please try again.",
      "WHATSAPP_WEBHOOK_TITLE": "Webhook-Verifizierungstoken",
      "WHATSAPP_WEBHOOK_SUBHEADER": "Mit diesem Token wird die Authentizität des Webhook Endpunktes überprüft.",
      "WHATSAPP_TEMPLATES_SYNC_TITLE": "Sync Templates",
      "WHATSAPP_TEMPLATES_SYNC_SUBHEADER": "Manually sync message templates from WhatsApp to update your available templates.",
      "WHATSAPP_TEMPLATES_SYNC_BUTTON": "Sync Templates",
      "WHATSAPP_TEMPLATES_SYNC_SUCCESS": "Templates sync initiated successfully. It may take a couple of minutes to update.",
      "WHATSAPP_MANUAL_MIGRATION": {
        "BANNER": {
          "TITLE": "Manual setup recommended",
          "DESCRIPTION": "This inbox connects through the shared Meta app used for embedded signup, which recent Meta restrictions have affected. To avoid similar issues in the future, we recommend reconnecting it with your own Meta app.",
          "START": "Start manual migration",
          "GUIDE": "View guide"
        },
        "DIALOG": {
          "EYEBROW": "WhatsApp manual migration",
          "TITLE": "Reconnect WhatsApp inbox",
          "CLOSE": "Schließen",
          "ACTION_REQUIRED_TITLE": "Reconnect with your own Meta app",
          "ACTION_REQUIRED_DESCRIPTION": "Inboxes connected through your own Meta app are not affected by restrictions on the shared embedded signup app. This guided flow updates the WhatsApp API connection without creating a new inbox.",
          "GUIDE_LINK": "Open the manual setup guide",
          "PRESERVED_TITLE": "Preserved",
          "PRESERVED_DESCRIPTION": "Conversations, contacts, collaborators, routing, business hours, and inbox settings.",
          "UPDATED_TITLE": "Updated",
          "UPDATED_DESCRIPTION": "WABA ID, phone number ID, access token, and webhook configuration.",
          "WABA_ID": "WABA ID",
          "WABA_PLACEHOLDER": "Enter WABA ID",
          "WABA_HELP": "The WhatsApp Business Account that owns this phone number.",
          "PHONE_NUMBER_ID": "Phone Number ID",
          "PHONE_NUMBER_PLACEHOLDER": "Enter Phone Number ID",
          "PHONE_NUMBER_HELP": "Meta's unique ID for the WhatsApp number connected to this inbox.",
          "DISPLAY_PHONE_NUMBER": "Display phone number",
          "DISPLAY_PHONE_NUMBER_PLACEHOLDER": "Enter display phone number",
          "DISPLAY_PHONE_NUMBER_HELP": "The customer-facing WhatsApp number. This cannot be changed during migration.",
          "ACCESS_TOKEN": "Permanent access token or system user token",
          "ACCESS_TOKEN_PLACEHOLDER": "Paste access token",
          "TOKEN_HELP_PREFIX": "The token must include",
          "TOKEN_HELP_MIDDLE": "Hinzufügen",
          "TOKEN_HELP_SUFFIX": "for template sync and template management.",
          "MESSAGING_PERMISSION": "whatsapp_business_messaging.",
          "MANAGEMENT_PERMISSION": "whatsapp_business_management",
          "REVIEW_TITLE": "Review before reconnecting",
          "INBOX": "Posteingang",
          "PHONE_NUMBER": "Telefonnummer",
          "NOT_ENTERED": "Not entered",
          "VERIFY_NOTICE": "Chatwoot will verify these credentials with Meta before applying any changes. If verification fails, the current configuration is left untouched.",
          "BACK": "Zurück",
          "CANCEL": "Stornieren",
          "CONTINUE": "Continue",
          "REVIEW_MIGRATION": "Review migration",
          "RECONNECT": "Reconnect WhatsApp inbox"
        },
        "STEPS": {
          "BEFORE_YOU_START": {
            "TITLE": "Before you start",
            "DESCRIPTION": "This reconnects the WhatsApp API details for this inbox. Conversations, collaborators, routing, business hours, CSAT, and bot settings will be preserved."
          },
          "BUSINESS_DETAILS": {
            "TITLE": "Business details",
            "DESCRIPTION": "Enter the WhatsApp assets from the customer Meta Business account."
          },
          "ACCESS_TOKEN": {
            "TITLE": "Access token",
            "DESCRIPTION": "Paste a permanent access token or system user token with WhatsApp permissions."
          },
          "REVIEW_MIGRATION": {
            "TITLE": "Review migration",
            "DESCRIPTION": "Confirm the connection details before reconnecting this inbox. Chatwoot will verify the token, WABA, and phone number with Meta before applying changes."
          }
        }
      },
      "WHATSAPP_CALLING_ENABLED": {
        "LABEL": "Enable voice calling",
        "DESCRIPTION": "Allow agents to start and receive WhatsApp voice calls on this inbox. Available only on embedded-signup WhatsApp Cloud channels with calling permission granted by Meta."
      },
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Pre Chat Einstellungen aktualisieren"
    },
    "HELP_CENTER": {
      "LABEL": "Hilfezentrum",
      "PLACEHOLDER": "Hilfezentrum auswählen",
      "SELECT_PLACEHOLDER": "Hilfezentrum auswählen",
      "NONE": "Keine",
      "REMOVE": "Hilfezentrum entfernen",
      "SUB_TEXT": "Ein Hilfezentrum am Posteingang anhängen"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Limit für automatische Zuweisung",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Bitte geben Sie einen Wert größer als 0 ein",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Beschränken Sie die maximale Anzahl von Konversationen aus diesem Posteingang, die einem Agenten automatisch zugewiesen werden können"
    },
    "ASSIGNMENT": {
      "TITLE": "Konversationssauftrag",
      "DESCRIPTION": "Automatically assign incoming conversations to available agents based on assignment policies",
      "ENABLE_AUTO_ASSIGNMENT": "Enable automatic conversation assignment",
      "DEFAULT_RULES_TITLE": "Default assignment rules",
      "DEFAULT_RULES_DESCRIPTION": "Using the default assignment behavior for all conversations",
      "DEFAULT_RULE_1": "Earliest created conversations first",
      "DEFAULT_RULE_2": "Round robin distribution",
      "CUSTOMIZE_WITH_POLICY": "Customize with assignment policy",
      "USING_POLICY": "Using custom assignment policy for this inbox",
      "CUSTOMIZE_POLICY": "Customize with assignment policy",
      "DELETE_POLICY": "Delete policy",
      "POLICY_LABEL": "Assignment policy",
      "ASSIGNMENT_ORDER_LABEL": "Assignment Order",
      "ASSIGNMENT_METHOD_LABEL": "Assignment Method",
      "POLICY_STATUS": {
        "ACTIVE": "Aktiv",
        "INACTIVE": "Inactive"
      },
      "PRIORITY": {
        "EARLIEST_CREATED": "Earliest created",
        "LONGEST_WAITING": "Longest waiting"
      },
      "METHOD": {
        "ROUND_ROBIN": "Round robin",
        "BALANCED": "Balanced assignment"
      },
      "UPGRADE_PROMPT": "Custom assignment policies are available on the Business plan",
      "UPGRADE_TO_BUSINESS": "Upgrade to Business",
      "DEFAULT_POLICY_LINKED": "Default policy linked",
      "DEFAULT_POLICY_DESCRIPTION": "Link a custom assignment policy to customize how conversations are assigned to agents in this inbox.",
      "LINK_EXISTING_POLICY": "Link existing policy",
      "CREATE_NEW_POLICY": "Create new policy",
      "NO_POLICIES": "No assignment policies found",
      "VIEW_ALL_POLICIES": "View all policies",
      "CURRENT_BEHAVIOR": "Currently using default assignment behavior:",
      "LINK_SUCCESS": "Assignment policy linked successfully",
      "LINK_ERROR": "Failed to link assignment policy"
    },
    "ASSIGNMENT_POLICY": {
      "DELETE_CONFIRM_TITLE": "Delete assignment policy?",
      "DELETE_CONFIRM_MESSAGE": "Are you sure you want to remove this assignment policy from this inbox? The inbox will revert to default assignment rules.",
      "CANCEL": "Stornieren",
      "CONFIRM_DELETE": "Löschen",
      "DELETE_SUCCESS": "Assignment policy removed successfully",
      "DELETE_ERROR": "Failed to remove assignment policy"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Neu autorisieren",
      "SUBTITLE": "Ihre Facebook-Verbindung ist abgelaufen, bitte verbinden Sie sich neu, um die Dienste fortzuführen",
      "MESSAGE_SUCCESS": "Wiederverbindung erfolgreich",
      "MESSAGE_ERROR": "Es ist ein Fehler aufgetreten, bitte versuchen Sie es erneut"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Pre-Chat-Formulare ermöglichen es Ihnen, Benutzerinformationen zu erfassen, bevor sie mit Ihnen ins Gespräch kommen.",
      "SET_FIELDS": "Formularfelder vor dem Chat",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Felder",
        "LABEL": "Label",
        "PLACE_HOLDER": "Platzhalter",
        "KEY": "Schlüssel",
        "TYPE": "Typ",
        "REQUIRED": "Benötigt"
      },
      "ENABLE": {
        "LABEL": "Vorab Chatformulare aktivieren",
        "OPTIONS": {
          "ENABLED": "Ja",
          "DISABLED": "Nein"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Pre-Chat-Nachricht",
        "PLACEHOLDER": "Diese Nachricht ist für alle Benutzer dieses Formulars sichtbar"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Besucher sollten ihren Namen und ihre E-Mail-Adresse angeben, bevor sie den Chat starten"
      }
    },
    "CSAT": {
      "TITLE": "CSAT aktivieren",
      "SUBTITLE": "Automatically trigger CSAT surveys at the end of conversations to understand how customers feel about their support experience. Track satisfaction trends and identify areas for improvement over time.",
      "DISPLAY_TYPE": {
        "LABEL": "Display type"
      },
      "MESSAGE": {
        "LABEL": "Nachricht",
        "PLACEHOLDER": "Please enter a message to show users with the form"
      },
      "BUTTON_TEXT": {
        "LABEL": "Button text",
        "PLACEHOLDER": "Please rate us"
      },
      "LANGUAGE": {
        "LABEL": "Sprache",
        "PLACEHOLDER": "Select template language"
      },
      "MESSAGE_PREVIEW": {
        "LABEL": "Message preview",
        "TOOLTIP": "This may vary slightly when rendered on WhatsApp's platform."
      },
      "TEMPLATE_STATUS": {
        "APPROVED": "Approved by WhatsApp",
        "PENDING": "Pending WhatsApp approval",
        "REJECTED": "Meta rejected the template",
        "DEFAULT": "Needs WhatsApp approval",
        "NOT_FOUND": "Die Voralge ist auf der Meta-Plattform nicht vorhanden."
      },
      "TEMPLATE_CREATION": {
        "SUCCESS_MESSAGE": "WhatsApp template created successfully and sent for approval",
        "ERROR_MESSAGE": "Failed to create WhatsApp template"
      },
      "TEMPLATE_UPDATE_DIALOG": {
        "TITLE": "Edit survey details",
        "DESCRIPTION": "Wir löschen die vorherige Vorlage und erstellen eine neue, die erneut zur Genehmigung durch WhatsApp gesendet wird",
        "CONFIRM": "Create new template",
        "CANCEL": "Zurück"
      },
      "UTILITY_ANALYZER": {
        "ACTION": "Check utility fit",
        "HELPER_NOTE": "Check this message before submission to improve Utility fit. The system creates a dedicated CSAT template with buttons for reporting and submits it as Utility; Meta may still reclassify it as Marketing based on content.",
        "RESULT_LABEL": "Meta category prediction",
        "GUIDANCE_NOTE": "This is a guidance check, not a guarantee of Meta approval.",
        "SUGGESTION_LABEL": "Suggested utility-safe rewrite",
        "APPLY": "Use this rewrite",
        "ERROR_MESSAGE": "Couldn't analyze the message. Please try again.",
        "CLASSIFICATION": {
          "LIKELY_UTILITY": "Likely Utility",
          "LIKELY_MARKETING": "Likely Marketing",
          "UNCLEAR": "Needs clarification"
        }
      },
      "SURVEY_RULE": {
        "LABEL": "Survey rule",
        "DESCRIPTION_PREFIX": "Send the survey if the conversation",
        "DESCRIPTION_SUFFIX": "any of the labels",
        "OPERATOR": {
          "CONTAINS": "enthält",
          "DOES_NOT_CONTAINS": "beinhaltet nicht"
        },
        "SELECT_PLACEHOLDER": "select labels"
      },
      "NOTE": "Note: CSAT surveys are sent only once per conversation",
      "WHATSAPP_NOTE": "Note: When you save, the system creates a dedicated CSAT template in WhatsApp (used to capture rating and feedback in reports) and submits it as Utility for approval. Meta may still classify it as Marketing based on content. After approval, surveys are sent only once per conversation as per the survey rule.",
      "API": {
        "SUCCESS_MESSAGE": "CSAT settings updated successfully",
        "ERROR_MESSAGE": "We couldn't update CSAT settings. Please try again later."
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Legen Sie Ihre Verfügbarkeit fest",
      "SUBTITLE": "Legen Sie die Verfügbarkeit für das Live-Chat-Widget fest",
      "WEEKLY_TITLE": "Wöchentliche Stunden festlegen",
      "TIMEZONE_LABEL": "Zeitzone auswählen",
      "UPDATE": "Einstellungen für Geschäftszeiten aktualisieren",
      "TOGGLE_AVAILABILITY": "Geschäftszeiten für diesen Posteingang aktivieren",
      "UNAVAILABLE_MESSAGE_LABEL": "Nachricht für Besucher außerhalb Geschäftszeiten",
      "TOGGLE_HELP": "Wenn die Geschäftsverfügbarkeit aktiviert ist, werden die verfügbaren Stunden im Live-Chat-Widget angezeigt, auch wenn alle Agenten offline sind. Außerhalb der verfügbaren Stunden können Besucher mit einer Nachricht und einem Chat-Formular gewarnt werden.",
      "DAY": {
        "DAY": "Tag",
        "AVAILABILITY": "Verfügbarkeit",
        "HOURS": "Hours",
        "ENABLE": "Verfügbarkeit für diesen Tag aktivieren",
        "UNAVAILABLE": "Nicht verfügbar",
        "VALIDATION_ERROR": "Die Startzeit sollte vor der Schließzeit liegen.",
        "CHOOSE": "Auswählen"
      },
      "ALL_DAY": "Den ganzen Tag"
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Setzen Sie Ihre IMAP-Daten",
      "NOTE_TEXT": "Um SMTP zu aktivieren, konfigurieren Sie bitte IMAP.",
      "UPDATE": "IMAP-Einstellungen aktualisieren",
      "TOGGLE_AVAILABILITY": "IMAP-Konfiguration für diesen Posteingang aktivieren",
      "TOGGLE_HELP": "Wenn IMAP aktiviert ist, kann der Benutzer E-Mails empfangen",
      "EDIT": {
        "SUCCESS_MESSAGE": "IMAP-Einstellungen erfolgreich aktualisiert",
        "ERROR_MESSAGE": "IMAP-Einstellungen können nicht aktualisiert werden"
      },
      "ADDRESS": {
        "LABEL": "Adresse",
        "PLACE_HOLDER": "Adresse (zB: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Login",
        "PLACE_HOLDER": "Einloggen"
      },
      "PASSWORD": {
        "LABEL": "Passwort",
        "PLACE_HOLDER": "Passwort"
      },
      "ENABLE_SSL": "SSL aktivieren",
      "AUTH_MECHANISM": "Authentifizierung"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "MICROSOFT-Konto erneut autorisieren"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Setzen Sie Ihre SMTP-Details",
      "UPDATE": "SMTP-Einstellungen aktualisieren",
      "TOGGLE_AVAILABILITY": "Die SMTP-Konfiguration für diesen Posteingang aktivieren",
      "TOGGLE_HELP": "Das Aktivieren von SMTP hilft dem Benutzer beim Senden von E-Mails",
      "EDIT": {
        "SUCCESS_MESSAGE": "SMTP-Einstellungen erfolgreich aktualisiert",
        "ERROR_MESSAGE": "SMTP-Einstellungen können nicht aktualisiert werden"
      },
      "ADDRESS": {
        "LABEL": "Adresse",
        "PLACE_HOLDER": "Adresse (zB: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Einloggen",
        "PLACE_HOLDER": "Einloggen"
      },
      "PASSWORD": {
        "LABEL": "Passwort",
        "PLACE_HOLDER": "Passwort"
      },
      "DOMAIN": {
        "LABEL": "Domain",
        "PLACE_HOLDER": "Domain"
      },
      "ENCRYPTION": "Verschlüsselung",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "SSL-Überprüfungsmodus öffnen",
      "AUTH_MECHANISM": "Authentifizierung"
    },
    "NOTE": "Hinweis: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Website-Avatar",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar erfolgreich gelöscht",
              "ERROR_MESSAGE": "Es ist ein Fehler aufgetreten, bitte versuchen Sie es erneut"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Webseiten-Name",
          "PLACE_HOLDER": "Geben Sie den Namen Ihrer Website ein (zum Beispiel: Acme Inc)",
          "ERROR": "Bitte geben Sie einen gültigen Website-Namen ein"
        },
        "WELCOME_HEADING": {
          "LABEL": "Willkommens-Überschrift",
          "PLACE_HOLDER": "Hi!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Willkommens-Schlagzeile",
          "PLACE_HOLDER": "Wir machen es einfach, sich mit uns zu verbinden. Fragen Sie uns etwas oder teilen Sie uns Ihr Feedback mit."
        },
        "REPLY_TIME": {
          "LABEL": "Antwortzeit",
          "IN_A_FEW_MINUTES": "Innerhalb weniger Minuten",
          "IN_A_FEW_HOURS": "Innerhalb weniger Stunden",
          "IN_A_DAY": "Innerhalb eines Tages"
        },
        "WIDGET_COLOR_LABEL": "Widget Farbe",
        "WIDGET_BUBBLE": "Bubble",
        "WIDGET_BUBBLE_POSITION_LABEL": "Position:",
        "WIDGET_BUBBLE_TYPE_LABEL": "Typ:",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Chatten Sie mit uns",
          "LABEL": "Launcher Title",
          "PLACE_HOLDER": "Chatten Sie mit uns"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Widget-Einstellungen aktualisieren",
          "API": {
            "SUCCESS_MESSAGE": "Widget-Einstellungen erfolgreich aktualisiert",
            "ERROR_MESSAGE": "Widget-Einstellungen können nicht aktualisiert werden"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Vorschau",
          "SCRIPT": "Script"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Links",
          "RIGHT": "Rechts"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standard",
          "EXPANDED_BUBBLE": "Erweiterte Blase"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Standard",
        "CHAT": "Chat mode"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Wir antworten üblicherweise innerhalb weniger Minuten",
        "IN_A_FEW_HOURS": "Wir antworten üblicherweise innerhalb weniger Stunden",
        "IN_A_DAY": "Wir antworten üblicherweise innerhalb eines Tages"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Konversation beginnen",
        "CHAT_INPUT_PLACEHOLDER": "Schreiben Sie Ihre Nachricht"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Wir sind online",
          "OFFLINE": "Wir sind momentan abwesend"
        },
        "USER_MESSAGE": "Hi",
        "AGENT_MESSAGE": "Hallo"
      },
      "BRANDING_TEXT": "Unterstützt von Chatwoot",
      "SCRIPT_SETTINGS": "\n      window.chatwootSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": {
        "TITLE": "Microsoft",
        "DESCRIPTION": "Connect with Microsoft"
      },
      "GOOGLE": {
        "TITLE": "Google",
        "DESCRIPTION": "Connect with Google"
      },
      "OTHER_PROVIDERS": {
        "TITLE": "Andere Anbieter",
        "DESCRIPTION": "Connect with Other Providers"
      }
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Webseite",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "EMAIL": "E-Mail",
      "TELEGRAM": "Telegramm",
      "LINE": "Line",
      "API": "API-Kanal",
      "INSTAGRAM": "Instagram",
      "TIKTOK": "TikTok",
      "VOICE": "Voice"
    }
  }
}
